// src/contexts/StreamingContext.jsx
import React, { createContext, useContext, useState } from "react";

const StreamingContext = createContext();

export const StreamingProvider = ({ children }) => {
  const [streamUrl, setStreamUrl] = useState("");

  return (
    <StreamingContext.Provider value={{ streamUrl, setStreamUrl }}>
      {children}
    </StreamingContext.Provider>
  );
};

export const useStreaming = () => useContext(StreamingContext);
